import { Button } from 'antd';
import { ButtonType } from 'antd/es/button';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { haltClickEventPropagation } from '@lib/events';
import React from 'react';
import { ConfirmDelete, ConfirmDeleteProps } from './ConfirmDelete';

export interface ConfirmDeleteButtonProps extends ConfirmDeleteProps {
	buttonClassName?: string;
	buttonId?: string;
	buttonLabel?: string;
	disabled?: boolean;
	type?: ButtonType;
}

export const ConfirmDeleteButton: React.FC<ConfirmDeleteButtonProps> = ({
	buttonClassName,
	buttonId,
	buttonLabel = COPY_SPECIFIC.DELETE,
	disabled,
	type = 'default',
	...rest
}) =>
	<ConfirmDelete { ...rest }>
		<Button
			className={ classNames('delete-button', buttonClassName) }
			danger
			disabled={ disabled }
			id={ buttonId }
			onClick={ haltClickEventPropagation }
			type={ type }>
			{ buttonLabel }
		</Button>
	</ConfirmDelete>;

